<div class="main-page-area">
    <div class="main-page-content">
        <eff-step-header
            [ngClass]="{ 'is-step-rejected': pageState.isRejected }"
            [controlGuid]="effectivenessModel.controlGuid"
            [hideSaveButton]="!stepPermissions.isEditAllowed"
            [title]="'effWorkflowSteps.uploadEvidence' | t"
            (onShowInstructions)="toggleInstructions()"
            (onSaveChanges)="saveChanges()"
        >
        </eff-step-header>
        @if (pageState.isRejected) {
            <author-message-box
                [author]="pageState.rejectedBy"
                [authorLabelKey]="pageState.rejectedByRoleKey"
                [message]="pageState.rejectionMessage"
            >
            </author-message-box>
        }
        <eff-checkbox
            data-uiid="eff-test-upload-evidence-expand-collapse-all"
            class="expand-collapse-all"
            [label]="'effGrid.openAll' | t"
            (modelChange)="expandCollapseAll($event)"
        ></eff-checkbox>
        <div class="main-grid d-flex flex-column">
            @for (viewSample of viewSamples; track viewSample) {
                <div>
                    <div class="grid-header">
                        <div class="bold-text" data-uiid="eff-test-upload-evidence-grid-header">
                            {{ 'effGrid.sampleLabel' | t: { name: viewSample.sample.name } }}
                        </div>
                        <eff-inline-text-editor
                            [label]="'effGrid.addSampleRemark' | t"
                            [(model)]="viewSample.sample.remarks"
                            [disabled]="!stepPermissions.isEditSampleRemarkAllowed"
                            (complete)="saveRemarksChange(viewSample.sample)"
                        ></eff-inline-text-editor>
                        @if (viewSample.sample.taskData) {
                            <div
                                class="task-link-label"
                                (click)="openTask(viewSample.sample.taskData)"
                            >
                                <i class="fas fa-regular fa-link-horizontal"></i>
                                <label>
                                    {{ viewSample.sample.taskData.actionDate | dateFormat }}</label
                                >
                            </div>
                        }
                    </div>
                    <eff-table
                        [dataSource]="viewSample.gridDataSource"
                        [columns]="displayedColumns"
                        [tableConfig]="tableConfig"
                        [expandedRowTemplate]="
                            pageState.isRejected ? rejectedExpandedTemplate : expandedTemplate
                        "
                    >
                        <ng-template #rejectedExpandedTemplate let-item="item">
                            <div class="grid-expanded-row rejected-layout">
                                <div
                                    class="table-row"
                                    data-uiid="eff-test-upload-evidence-rejected-row"
                                >
                                    <div class="table-cell documents">
                                        @if (!item.noEvidence || hasNoEvidenceAndDocuments(item)) {
                                            <documents-list
                                                class="documets-list-small-droparea"
                                                [documents]="item.documents"
                                                [canAdd]="stepPermissions.evidenceSaveAllowed"
                                                [canEdit]="stepPermissions.evidenceSaveAllowed"
                                                [canDelete]="stepPermissions.evidenceSaveAllowed"
                                                (documentsChange)="onDocumentsChanged()"
                                                [taskDocuments]="item.taskData?.documents"
                                                [isSample]="item.isSample"
                                                (documentsChange)="documentsChange($event, item)"
                                                data-uiid="eff-test-upload-evidence-rejected-documents-list"
                                            ></documents-list>
                                        }
                                        @if (hasNoEvidenceAndDocuments(item)) {
                                            <div class="documents-and-no-evidence-spacing"></div>
                                        }
                                        @if (
                                            totalDocumentCount(item) === 0 ||
                                            hasNoEvidenceAndDocuments(item)
                                        ) {
                                            <div>
                                                <ng-container
                                                    *ngTemplateOutlet="
                                                        noEvidenceTemplate;
                                                        context: { item: item }
                                                    "
                                                ></ng-container>
                                            </div>
                                        }
                                    </div>
                                    <div class="table-cell tester-comment">
                                        <div class="comment">
                                            <eff-textarea
                                                class="grid-textarea-style"
                                                [(model)]="item.commentTester"
                                                [bordered]="false"
                                                [disabled]="true"
                                                uiid="tester-comment"
                                                [popupTitle]="'effGrid.commentTester' | t"
                                                [label]="'effGrid.addComment' | t"
                                            ></eff-textarea>
                                        </div>
                                    </div>
                                    <div class="table-cell tester-score">
                                        @if (item.IsExpanded) {
                                            <div>
                                                <ng-container
                                                    *ngTemplateOutlet="
                                                        testerScoreView;
                                                        context: { item: item }
                                                    "
                                                ></ng-container>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                        <ng-template #expandedTemplate let-item="item">
                            <div class="d-flex flex-column grid-expanded-row normal-layout">
                                @if (!item.noEvidence) {
                                    <documents-list
                                        [ngClass]="{
                                            'has-evidence': totalDocumentCount(item) > 0,
                                        }"
                                        [documents]="item.documents"
                                        [canAdd]="stepPermissions.evidenceSaveAllowed"
                                        [canEdit]="stepPermissions.evidenceSaveAllowed"
                                        [canDelete]="stepPermissions.evidenceSaveAllowed"
                                        (documentsChange)="onDocumentsChanged()"
                                        [taskDocuments]="item.taskData?.documents"
                                        [isSample]="item.isSample"
                                        data-uiid="eff-test-upload-evidence-documents-list"
                                        (documentsChange)="documentsChange($event, item)"
                                    ></documents-list>
                                }
                                @if (totalDocumentCount(item) === 0) {
                                    <div>
                                        <ng-container
                                            *ngTemplateOutlet="
                                                noEvidenceTemplate;
                                                context: { item: item }
                                            "
                                        ></ng-container>
                                    </div>
                                }
                                @if (
                                    item.taskData &&
                                    item.taskData.workflowStatus !== taskWorkflowStatusDone
                                ) {
                                    <div class="no-task-evidence-warning">
                                        {{ 'effTestingUploadEvidence.controlExecutionNotFinishedWarning' | t }}
                                        <ul>
                                            <li>
                                                {{ 'effTestingUploadEvidence.makeControlExecutionCompleted' | t }}
                                            </li>
                                            <li>
                                                {{ 'effTestingUploadEvidence.orManuallyUpload' | t }}
                                            </li>
                                            <li>{{ 'effTestingUploadEvidence.orContinueWithout' | t }}</li>
                                        </ul>
                                    </div>
                                }
                            </div>
                        </ng-template>
                        <ng-template column-name="name" let-item="item">
                            <div class="d-flex flex-row gap-3 align-items-center">
                                <div
                                    [ngClass]="{ 'sample-name-cell': item.isSample }"
                                    class="regular-text"
                                    data-uiid="eff-test-upload-evidence-name"
                                >
                                    {{ (item.isSample ? 'effTestingUploadEvidence.sample' : 'effTestingUploadEvidence.step') | t }} {{ item.name }}
                                </div>
                                @if (totalDocumentCount(item) > 0) {
                                    <div class="d-flex flex-row align-items-center gap-1">
                                        <eff-icon
                                            class="remark-icon"
                                            icon="attachment_outlined"
                                        ></eff-icon>
                                        <div>({{ totalDocumentCount(item) }})</div>
                                    </div>
                                }
                                @if (item.noEvidence && item.noEvidenceReason) {
                                    <div>
                                        <eff-icon
                                            class="remark-icon"
                                            icon="comment_outlined"
                                        ></eff-icon>
                                    </div>
                                }
                                @if (
                                    item.isSample &&
                                    !item.noEvidence &&
                                    item.taskData &&
                                    item.taskData.workflowStatus !== taskWorkflowStatusDone &&
                                    totalDocumentCount(item) === 0
                                ) {
                                    <div>
                                        <i
                                            class="far fa-regular fa-triangle-exclamation warning-icon"
                                        ></i>
                                    </div>
                                }
                            </div>
                        </ng-template>
                        <ng-template column-name="evidence" let-item="item">
                            <div
                                class="d-flex flex-row align-items-center status-cell"
                                data-uiid="eff-test-upload-evidence-status"
                            >
                                <div
                                    class="status-bullet"
                                    data-uiid="eff-test-upload-evidence-status-bullet"
                                    [ngClass]="
                                        getEvidenceStatusClass(item, viewSample.gridDataSource.data)
                                    "
                                ></div>
                                <div
                                    class="regular-text"
                                    data-uiid="eff-test-upload-evidence-status-text"
                                >
                                    {{
                                        getEvidenceStatusText(item, viewSample.gridDataSource.data)
                                    }}
                                </div>
                            </div>
                        </ng-template>
                        <ng-template column-name="testerComment" let-item="item">
                            @if (!item.IsExpanded && item.commentTester) {
                                <div>
                                    <eff-icon
                                        class="remark-icon"
                                        icon="comment_outlined"
                                    ></eff-icon>
                                </div>
                            }
                        </ng-template>
                        <ng-template column-name="score" let-item="item">
                            @if (!item.IsExpanded) {
                                <div>
                                    <ng-container
                                        *ngTemplateOutlet="testerScoreView; context: { item: item }"
                                    ></ng-container>
                                </div>
                            }
                        </ng-template>
                    </eff-table>
                </div>
            }
        </div>

        <ng-template #testerScoreView let-item="item">
            <div class="d-flex flex-row align-items-center status-cell">
                <div class="status-bullet" [ngClass]="getScoreColor(item)"></div>
                <div>
                    {{ item.scoreName }}
                </div>
            </div>
        </ng-template>

        <div class="bottom-buttons-wrapper">
            @if (stepPermissions.evidenceSaveAllowed) {
                <eff-button
                    data-uiid="eff-test-upload-evidence-save-changes"
                    [text]="'effTestingUploadEvidence.finishUploadingEvidence' | t"
                    size="large-size"
                    class="bottom-button upload-evidence-btn"
                    (click)="completeEvidenceUpload()"
                ></eff-button>
            }
        </div>
    </div>

    <div class="side-page-area">
        <eff-evidence-instructions-info-box
            [panelOpenState]="true"
            [samples]="samples"
            [instructions]="effectivenessModel.evidenceUploadInstructions"
        >
        </eff-evidence-instructions-info-box>
        <eff-test-instructions-info-box
            [panelOpenState]="false"
            [samples]="samples"
            [effectivenessModel]="effectivenessModel"
        >
        </eff-test-instructions-info-box>
        <eff-source-document-info-box
            [effectivenessModel]="effectivenessModel"
            [stepPermissions]="stepPermissions"
        ></eff-source-document-info-box>
        <eff-control-info-box [controlGuid]="effectivenessModel.controlGuid"></eff-control-info-box>
    </div>
</div>

<ng-template #noEvidenceTemplate let-item="item">
    @if (item.isSample) {
        <div class="d-flex flex-column no-evidence-section">
            <eff-checkbox
                [(model)]="item.noEvidence"
                [disabled]="!stepPermissions.evidenceSaveAllowed"
                [label]="'effGrid.noEvidence' | t"
                (modelChange)="onChanges()"
                data-uiid="eff-testing-no-evidence-checkbox"
            ></eff-checkbox>
            @if (item.noEvidence) {
                <div class="d-flex flex-column">
                    <div class="label-text bold-text">{{ 'effTestingUploadEvidence.noEvidenceReason' | t }}</div>
                    <div class="no-evidence-comment">
                        <eff-textarea
                            class="no-evidence-textarea"
                            [(model)]="item.noEvidenceReason"
                            [disabled]="!stepPermissions.evidenceSaveAllowed"
                            [bordered]="stepPermissions.evidenceSaveAllowed"
                            [popupTitle]="'effGrid.commentNoEvidence' | t"
                            uiid="no-evidence"
                            (modelChange)="onChangesDebounce()"
                        ></eff-textarea>
                    </div>
                </div>
            }
        </div>
    }
</ng-template>

<cerrix-slide-over #cerrixSlideOver>
    <ng-template #title>
        <div class="paragraph">
            <div class="header">{{ 'effTestingUploadEvidence.howToUploadEvidenceTitle' | t }}</div>
        </div>
    </ng-template>
    <ng-template #content>
        <div class="paragraph">
            <div class="header">{{ 'effTestingUploadEvidence.uploadingEvidenceHeader' | t }}</div>
            <div class="content">
                {{ 'effTestingUploadEvidence.uploadingEvidenceIntro' | t }}
            </div>
        </div>
        <div class="paragraph">
            <div class="header">{{ 'effTestingUploadEvidence.addEvidenceHeader' | t }}</div>
            <div class="content">
                <ol>
                    <li>
                        {{ 'effTestingUploadEvidence.helpSelectSample' | t }}
                        <ol type="i">
                            <li>{{ 'effTestingUploadEvidence.helpChooseSample' | t }}</li>
                        </ol>
                    </li>
                    <li>
                        {{ 'effTestingUploadEvidence.helpUploadDocument' | t }}
                        <ol type="i">
                            <li>{{ 'effTestingUploadEvidence.helpClickAddDocument' | t }}</li>
                            <li>{{ 'effTestingUploadEvidence.helpDragDocuments' | t }}</li>
                        </ol>
                    </li>
                    <li>
                        {{ 'effTestingUploadEvidence.helpAdditionalInfo' | t }}
                        <ol type="i">
                            <li>{{ 'effTestingUploadEvidence.helpAddTypeAndDescription' | t }}</li>
                        </ol>
                    </li>
                    <li>
                        {{ 'effTestingUploadEvidence.helpSaveChanges' | t }}
                        <ol type="i">
                            <li>{{ 'effTestingUploadEvidence.helpClickSaveChangesButton' | t }}</li>
                        </ol>
                    </li>
                </ol>
            </div>
        </div>
        <div class="paragraph">
            <div class="header">{{ 'effTestingUploadEvidence.noAvailableEvidenceHeader' | t }}</div>
            <div class="content">
                <ol>
                    <li>
                        {{ 'effTestingUploadEvidence.helpIndicateNoEvidence' | t }}
                        <ol type="i">
                            <li>{{ 'effTestingUploadEvidence.helpClickNoEvidenceButton' | t }}</li>
                        </ol>
                    </li>
                    <li>
                        {{ 'effTestingUploadEvidence.helpReasonNoEvidence' | t }}
                        <ol type="i">
                            <li>{{ 'effTestingUploadEvidence.helpDescribeReason' | t }}</li>
                        </ol>
                    </li>
                    <li>
                        {{ 'effTestingUploadEvidence.helpSaveChanges' | t }}
                        <ol type="i">
                            <li>{{ 'effTestingUploadEvidence.helpClickSaveChangesToSave' | t }}</li>
                        </ol>
                    </li>
                </ol>
            </div>
        </div>
        <div class="paragraph">
            <div class="header">{{ 'effTestingUploadEvidence.completeEvidenceUploadHeader' | t }}</div>
            <div class="content">
                <ol>
                    <li>
                        {{ 'effTestingUploadEvidence.helpCheckSampleStatus' | t }}
                        <ol type="i">
                            <li>{{ 'effTestingUploadEvidence.helpEnsureEverySample' | t }}</li>
                        </ol>
                    </li>
                    <li>
                        {{ 'effTestingUploadEvidence.helpFinishProcess' | t }}
                        <ol type="i">
                            <li>{{ 'effTestingUploadEvidence.helpFinishButtonAvailable' | t }}</li>
                            <li>{{ 'effTestingUploadEvidence.helpClickToConclude' | t }}</li>
                        </ol>
                    </li>
                </ol>
            </div>
        </div>
    </ng-template>
</cerrix-slide-over>
